import axios from 'axios';
export default class NoticeService {
    async getNoticeList(data) {
        return await axios .post('api/v1/admin/notice/list', data);
    }
    // async addNotice(title, description, create_date) {
    //     return await axios
    //         .post(`api/v1/admin/notice/add`, {
    //             title: title,
    //             description: description,
    //             create_date: create_date,
    //         })
    //         .then((res) => res);
    // }
    async viewNotice(ids) {
        return await axios
            .post(`api/v1/admin/notice/details`, {
                notice_id: ids,
            })
            .then((res) => res.data.result);
    }
    async editNotice(data) {
        return await axios
            .post(`api/v1/admin/notice/edit`, data)
            .then((res) => res);
    }
}
